// Resumo de uma mensagem citada (reply/quote) para o preview — usado no balão
// do chat (MessagesList) e na caixa de escrever a resposta (MessageInput).
// Retorna { icon, text, thumb } onde thumb indica se há miniatura de mídia.
export default function quotedPreview(qm) {
  if (!qm) return { icon: "", text: "", thumb: false };
  const t = qm.mediaType;
  const body = (qm.body || "").trim();

  switch (t) {
    case "image":
      return { icon: "📷", text: body || "Foto", thumb: true };
    case "sticker":
      return { icon: "", text: "Figurinha", thumb: true };
    case "video":
      return { icon: "🎥", text: body || "Vídeo", thumb: false };
    case "audio":
    case "ptt":
      return { icon: "🎤", text: "Mensagem de voz", thumb: false };
    case "document":
      return { icon: "📄", text: body || "Documento", thumb: false };
    case "vcard":
    case "multi_vcard":
      return { icon: "👤", text: "Contato", thumb: false };
    case "location":
      return { icon: "📍", text: "Localização", thumb: false };
    default:
      if (body) return { icon: "", text: body, thumb: false };
      if (t && t !== "chat" && t !== "conversation")
        return { icon: "📎", text: "Anexo", thumb: false };
      return { icon: "", text: "", thumb: false };
  }
}
